import { SwiperSlide } from "swiper/react";
import { Common } from "..";
import { ERoute } from "../../constants";
import { IChannel, TContentConfigs } from "../../models/channel";
import ChannelCard from "./ChannelCard";

type TOwnProps = {
  subChannels?: IChannel[];
  contents?: TContentConfigs[];
  parentChannelId: string;
  parentChannelPath: string;
};

const ChannelSubItems = (props: TOwnProps) => {
  const { subChannels, contents, parentChannelId, parentChannelPath } = props;

  if (!subChannels?.length && !contents?.length) {
    return null;
  }

  return (
    <Common.Carousel total={subChannels?.length || contents?.length || 0}>
      {subChannels?.map((c) => (
        <SwiperSlide key={c.id}>
          <ChannelCard
            {...c}
            channelPath={`${parentChannelPath}/${c.title}`}
            path={`/${ERoute.CHANNEL}/${parentChannelId}+${c.id}`}
            cardImg={`${c.thumbnail}`}
          />
        </SwiperSlide>
      ))}
      {typeof contents !== "undefined" &&
        contents.length > 0 &&
        contents.map((content, idx) => (
          <SwiperSlide key={content.id}>
            <ChannelCard
              id={`${content.id}-${idx}`}
              channelPath={parentChannelPath}
              title={content.title}
              path={`/${ERoute.VIDEO}?id=${content.title}&videoId=${content.id}&channelPath=${parentChannelPath}&src=${content.sourcePath}`}
              cardImg={`${content.thumbnail}`}
            />
          </SwiperSlide>
        ))}
    </Common.Carousel>
  );
};
export default ChannelSubItems;
